import { computed, type Ref } from "vue";
import type { StatusTab } from "./StatusTabs.vue";

export interface StatusTabDef extends StatusTab {
  statuses: string[];
}

const sameStatuses = (a: string[], b: string[]) => a.length === b.length && a.every((status) => b.includes(status));

export const useStatusTabs = (
  statusFilter: Ref<string[]>,
  statusCounts: Ref<Record<string, number>>,
  tabsDef: StatusTabDef[],
  onSelect?: () => void,
) => {
  const countFor = (statuses: string[]) =>
    statuses.length === 0
      ? Object.values(statusCounts.value).reduce((sum, n) => sum + n, 0)
      : statuses.reduce((sum, status) => sum + (statusCounts.value[status] ?? 0), 0);

  const tabs = computed<StatusTab[]>(() => tabsDef.map((tab) => ({ ...tab, count: countFor(tab.statuses) })));

  const activeTab = computed({
    get: () => tabsDef.find((tab) => sameStatuses(tab.statuses, statusFilter.value))?.value ?? "",
    set: (value: string) => {
      statusFilter.value = [...(tabsDef.find((tab) => tab.value === value)?.statuses ?? [])];
      onSelect?.();
    },
  });

  const tabFilterCount = computed(() => (tabsDef.find((tab) => tab.value === activeTab.value)?.statuses.length ? 1 : 0));

  return { tabs, activeTab, tabFilterCount };
};
